import { Box, Card, CardActionArea, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import type { CategoriaDocumento } from './documentos.constants';

interface DocumentoCategoriaCardProps {
  categoria: CategoriaDocumento;
  total: number;
  activa: boolean;
  onClick: () => void;
}

export default function DocumentoCategoriaCard({ categoria, total, activa, onClick }: DocumentoCategoriaCardProps) {
  const { label, icon: Icon, color } = categoria;

  return (
    <Card
      elevation={0}
      sx={{
        height: '100%',
        borderRadius: 2,
        border: '2px solid',
        borderColor: activa ? `${color}.main` : 'grey.200',
        //borderTop: '4px solid',
        //borderTopColor: `${color}.main`,
        bgcolor: (theme) => (activa ? alpha(theme.palette[color].main, 0.06) : 'background.paper'),
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': { transform: 'translateY(-2px)', boxShadow: 3 },
      }}
    >
      <CardActionArea onClick={onClick} aria-pressed={activa} sx={{ p: 2, height: '100%' }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
          <Box>
            <Typography variant="caption" color="text.secondary" fontWeight={600}>
              {label}
            </Typography>
            <Typography variant="h4" fontWeight={700} color={`${color}.main`}>
              {total}
            </Typography>
          </Box>
          <Box
            sx={{
              width: 44,
              height: 44,
              flexShrink: 0,
              borderRadius: '50%',
              display: 'grid',
              placeItems: 'center',
              color: `${color}.main`,
              bgcolor: (theme) => alpha(theme.palette[color].main, 0.12),
            }}
          >
            <Icon />
          </Box>
        </Stack>
      </CardActionArea>
    </Card>
  );
}
